import React, { useEffect, useState } from "react";
import logoclr from "../images/logoclr.png";
import { useParams } from "react-router-dom";
import Config from "../Config/Config";
import axios from "axios";
import moment from "moment";


const View_booking = () => {
    const { id } = useParams();
    const [ApiResponse, setApiResponse] = useState({});
    const LoginUsers = JSON.parse(localStorage.getItem('AccessLogin')) ?? {};
    useEffect(() => {

        let paylods = {
            "_id": `${id}`
        }

        axios.post(`${Config.API_URL}/api/customer/booking/details`, paylods, {
            headers: {
                Authorization: `${Config.API_ACCESS_TOKEN}`
            }
        })
            .then((response) => {
                console.log(response.data)
                if (response.data.status) {
                    setApiResponse(response.data.data)
                } else {
                    setApiResponse([])
                }
            })
            .catch(err => {
                console.log(err);
                setApiResponse([])
            })
    }, [])

    const handlePaymentShow = (ApiResponse = '') => {
        // ApiResponse.payment_mode === 'wallet' ? 'Online' : 'Cash'
        switch (ApiResponse?.payment_mode) {
            case 'wallet':
                return 'Online'
            case 'advance':
                return 'Advance'
            default:
                return 'Cash'
        }
    }

    const dropCityName = (ApiResponse = '') => {

        if(!ApiResponse) {
            return 'N/A';
        }

        switch (ApiResponse.trip_type) {
            case 'outstation':
                let TraveltRootsArrays = ApiResponse.travel_route.split('|');
                return TraveltRootsArrays[TraveltRootsArrays.length - 2];
            case 'local':
                return ApiResponse.package_name;
            default:
                return ApiResponse.to_city
        }
    }

    console.log(ApiResponse, 'this is api response From the booking Listing');

    return (
        <>
            <div className="wd_dashcontent">
                <div className="container bookingpg">
                    <div className="row">
                        <h3>My Booking</h3>
                    </div>
                    <div className="row bookngview">
                        <div className="boknghdr">
                            <img src={logoclr} />
                            <p className="bookid">Booking ID - {ApiResponse.booking_id}</p>
                        </div>
                        <div className="bkngloc">
                            <p>{ApiResponse.from_city} {">"} {ApiResponse.travel_route}</p>
                        </div>
                        <div className="vwbkng_dtls">
                            <div className="vbkngrow">
                                <p>Pickup from: <span>{ApiResponse.from_city}</span></p>
                                <p>Pickup Address: <span>{ApiResponse.pickup_address}</span></p>
                                <p>Pickup Date: <span>{moment(ApiResponse.pickup_date).format("DD/MM/YYYY hh:mm A")}</span></p>
                                <p>Drop To: <span>{dropCityName(ApiResponse)}</span></p>
                                <p>Drop Address: <span>{ApiResponse.drop_address}</span></p>
                                <p>Drop Date: <span>{moment(ApiResponse.drop_date).format('DD/MM/YYYY')}</span></p>
                                <p>Trip Type: <span>{ApiResponse.trip_type}</span></p>
                            </div>
                            <div className="vbkngrow">
                                <p>Customer Name: <span>{ApiResponse.user_name}</span></p>
                                <p>Email ID: <span>{ApiResponse.user_email}</span></p>
                                <p>Company: <span>{ApiResponse.company_name ? ApiResponse.company_name : 'N/A'}</span></p>
                                <p>Mobile number: <span>{ApiResponse.user_mobile}</span></p>
                                <p>Flight number: <span>-</span></p>
                                <p>GSTID: <span>{ApiResponse.gstin_number ? ApiResponse.gstin_number : 'N/A'}</span></p>
                            </div>
                            <div className="vbkngrow">
                                <p>Fare / KM:<span>{ApiResponse.per_km_charge} INR</span></p>
                                <p>Estimated KM: <span>{ApiResponse.estimated_kms} KM</span></p>
                                <p>Amount:<span>{ApiResponse.total_trip_amount} INR</span></p>
                                <p>Min billable / KM: <span>{ApiResponse.fixed_kms} KM</span></p>
                                <p>Covered KM:<span>{ApiResponse.estimated_kms} KM</span></p>
                                <p>Payable Amount:<span>{ApiResponse.final_trip_amount} INR</span></p>
                                <p>Payment Mode:<span>{["cash", "advance"]?.includes(ApiResponse.payment_mode) ? "Pay To Driver" : ApiResponse.payment_mode}</span></p>
                                <p>Payment Type:<span>{handlePaymentShow(ApiResponse)}</span></p>
                                <p>Transaction ID:<span>{ApiResponse.booking_id}</span></p>
                            </div>
                            <div className="vbkngrow">
                                <p>Vehicle:<span>{ApiResponse.vehicle_category} ( {ApiResponse?.vehicle_model} )</span></p>
                                <p>Vehicle no.: <span>{ApiResponse?.vehicle_no || "N/A"}</span></p>
                                <p>Driver name:<span>{ApiResponse?.driver_name || "N/A"}</span></p>
                                <p>Phone no.:<span>{ApiResponse?.driver_phone || "N/A"}</span></p>
                            </div>
                        </div>

                        <div className="p-4 text-center">
                            <div>
                                <a
                                    style={{
                                    backgroundColor: '#F4B045',
                                    color: '#323C42',
                                    padding: '10px 16px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                                    fontSize:'15px'
                                    }}
                                    href={`/Booking/slip/${ApiResponse?.booking_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = '#052c65'
                                        e.currentTarget.style.color = '#fff'
                                    }
                                    }
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = '#F4B045'
                                        e.currentTarget.style.color = '#323C42'
                                    }}
                                >
                                    View Booking Slips
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default View_booking;
